import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "13",
  viewBox: "0 0 19 13",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.7093 0.295132C19.0986 0.686889 19.0966 1.32005 18.7049 1.70934L7.6351 12.7093C7.24509 13.0969 6.61537 13.0969 6.22536 12.7093L6.93023 12C6.22536 12.7093 6.22538 12.7094 6.22536 12.7093L6.178 12.6623C6.16458 12.6489 6.18691 12.6711 6.17342 12.6577L0.295132 6.81648C-0.0966248 6.42719 -0.0986263 5.79403 0.290661 5.40227C0.679949 5.01052 1.31311 5.00852 1.70487 5.3978L6.19114 9.8558C6.23873 9.90309 6.16655 9.83137 6.21409 9.8786L6.31791 9.98177C6.30992 9.97383 6.29693 9.96093 6.32631 9.99012L6.93023 10.5902L17.2951 0.290661C17.6869 -0.0986263 18.3201 -0.0966248 18.7093 0.295132Z"
    }, null, -1)
  ]))]))
}
export default { render: render }